import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.194 4.4c-.401.006-.907.282-1.019 1.09-.079.57-.211 1.364-.37 2.3h1.84a.7.7 0 1 1 0 1.4h-2.08l-.005.034a185.495 185.495 0 0 0-.827 5.214c-.118.835-.427 1.49-.894 1.937-.471.45-1.056.644-1.621.624-1.087-.04-2.168-.894-2.168-2.19a.7.7 0 1 1 1.4 0c0 .425.361.774.818.79a.812.812 0 0 0 .603-.235c.187-.18.39-.518.476-1.121.25-1.774.54-3.528.798-5.052H6.192a.7.7 0 1 1 0-1.4h2.192c.177-1.038.322-1.896.404-2.493.204-1.476 1.276-2.28 2.384-2.298a2.194 2.194 0 0 1 1.502.548c.43.385.692.943.707 1.61a.7.7 0 1 1-1.4.033c-.006-.303-.116-.488-.242-.6a.795.795 0 0 0-.545-.19Zm-.056 6.704a.7.7 0 0 1 .99-.023l1.32 1.26 1.319-1.26a.7.7 0 1 1 .966 1.013l-1.272 1.214 1.272 1.214a.7.7 0 1 1-.966 1.013l-1.32-1.26-1.319 1.26a.7.7 0 1 1-.966-1.013l1.272-1.214-1.272-1.214a.7.7 0 0 1-.024-.99Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
